module.exports = __webpack_public_path__ + "img/allhouse_white_flag_transparent.bd5f1cf6.png";